/**
 * Logo Regula360 — "Arco Calibrado" (mostrador/gauge), igual ao da apresentação
 * comercial (deck 2026). Anel aberto com marcações de calibração + ponteiro no
 * topo e 3 marcas cardeais em cobre. Símbolo de medição/conformidade.
 *
 * Sempre desenhado em grafite (#1F2937) + cobre (#C0622D). No modo escuro
 * (sidebar) vai dentro de um chip branco arredondado pra dar contraste/destaque.
 *
 * Fonte do vetor: regula360-deck/logo-regula360-simbolo-{grafite,claro}.svg
 */
interface Props {
  size?: number;
  onDark?: boolean;
  className?: string;
}

// Marcações menores do mostrador (x1,y1,x2,y2) — todas menos cardeais/ponteiro.
const TICKS: ReadonlyArray<[number, number, number, number]> = [
  [61.29, 18.99, 60.26, 21.81], [66.5, 21.42, 65.0, 24.02], [71.21, 24.72, 69.28, 27.02],
  [75.28, 28.79, 72.98, 30.72], [78.58, 33.5, 75.98, 35.0], [81.01, 38.71, 78.19, 39.74],
  [82.5, 44.27, 79.54, 44.79], [82.5, 55.73, 79.54, 55.21], [81.01, 61.29, 78.19, 60.26],
  [78.58, 66.5, 75.98, 65.0], [75.28, 71.21, 72.98, 69.28], [71.21, 75.28, 69.28, 72.98],
  [66.5, 78.58, 65.0, 75.98], [61.29, 81.01, 60.26, 78.19], [55.73, 82.5, 55.21, 79.54],
  [44.27, 82.5, 44.79, 79.54], [38.71, 81.01, 39.74, 78.19], [33.5, 78.58, 35.0, 75.98],
  [28.79, 75.28, 30.72, 72.98], [24.72, 71.21, 27.02, 69.28], [21.42, 66.5, 24.02, 65.0],
  [18.99, 61.29, 21.81, 60.26], [17.5, 55.73, 20.46, 55.21], [17.5, 44.27, 20.46, 44.79],
  [18.99, 38.71, 21.81, 39.74], [21.42, 33.5, 24.02, 35.0], [24.72, 28.79, 27.02, 30.72],
  [28.79, 24.72, 30.72, 27.02], [33.5, 21.42, 35.0, 24.02], [38.71, 18.99, 39.74, 21.81],
];

export function LogoRegula({ size = 40, onDark = false, className = "" }: Props) {
  const ring = "#1F2937";
  const accent = "#C0622D";
  const svg = (
    <svg viewBox="0 0 100 100" style={{ height: size, width: size, display: "block" }} role="img" aria-label="Regula360">
      {/* Anel aberto */}
      <path d="M 59.43 12.16 A 39 39 0 1 1 40.57 12.16" fill="none" stroke={ring} strokeWidth={4.5} strokeLinecap="round" />
      {/* Marcações de calibração */}
      {TICKS.map(([x1, y1, x2, y2], i) => (
        <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={ring} strokeWidth={1.3} strokeLinecap="round" />
      ))}
      {/* Marcas cardeais (cobre) */}
      <line x1={83} y1={50} x2={76.5} y2={50} stroke={accent} strokeWidth={2.4} strokeLinecap="round" />
      <line x1={50} y1={83} x2={50} y2={76.5} stroke={accent} strokeWidth={2.4} strokeLinecap="round" />
      <line x1={17} y1={50} x2={23.5} y2={50} stroke={accent} strokeWidth={2.4} strokeLinecap="round" />
      {/* Ponteiro no topo + cabeça */}
      <line x1={50} y1={21} x2={50} y2={4} stroke={accent} strokeWidth={3.2} strokeLinecap="round" />
      <circle cx={50} cy={3} r={2.6} fill={accent} />
    </svg>
  );

  // No escuro (sidebar): chip branco arredondado dá destaque ao símbolo.
  if (onDark) {
    return (
      <div
        className={`inline-flex items-center justify-center bg-white rounded-lg shrink-0 ${className}`}
        style={{ height: size + 10, width: size + 10 }}
      >
        {svg}
      </div>
    );
  }
  return (
    <div className={`inline-flex items-center justify-center ${className}`} style={{ height: size, width: size }}>
      {svg}
    </div>
  );
}
